// White-label branding.
//
// When the app is served from an MDIS host (e.g. https://aits.mdis.in) we used
// to swap the default logo for a separate MDIS wordmark. Detection is by
// hostname: window.location.hostname is just the host ("aits.mdis.in") — no
// protocol and no path — so we match on that, NOT on the full URL.
//
// Both brand logos now point at the same artwork, so brandLogo() always
// returns the caller's default and brandLogoStyle() is a no-op — kept as
// pass-through functions (rather than removed) so call sites don't need to
// change, and so a future distinct white-label logo can drop back in here.

// Hosts whose domain contains "mdis.in" are treated as the MDIS white-label
// (covers aits.mdis.in and any future mdis.in subdomain). Add more brands here.
const isMdisHost = () => {
	if (typeof window === "undefined" || !window.location) return false;
	return window.location.hostname.toLowerCase().includes("mdis.in");
};

// True once per load when the current host is a white-labelled brand. Still
// used outside of logo selection (e.g. to hide/show white-label-only UI).
export const isWhiteLabel = isMdisHost();

// Always returns the caller's own default logo — see note above.
//   <img src={brandLogo(myclassroom_logo)} />
export const brandLogo = (defaultLogo) => defaultLogo;

// No backdrop needed now that both brands share the same artwork.
//   <img src={brandLogo(logo)} style={{ ...existing, ...brandLogoStyle }} />
export const brandLogoStyle = {};
